import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Util from './../../../../shared/util/util';
 import AddShipments from './../AddShipments';
 import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
 import startTrip from './startTrip';
 import draggable from 'vuedraggable'
 import moment from "moment";
 import AdminSettingsService from './../../../../adminsettings/services/adminsettings.service';

export default {
  name: 'createTripManagement',
  components: {
    BasicSelect,
    DatePicker,
    CustomExpandableTable,
    Pagination,
    startTrip,
    AddShipments,
    Treeselect,
    VueElementLoading,
    TripServices,
    'first': "Pickups",
    draggable,
  },
  props: ['parentObj'],
  data() {
    return {

        currentTab: 'First',
        componentKey:1,
        tabs: [
          { key:'First', value:'Pickups'}
            ],
      accordianTab:{1:false, 2:false,3:false,4:false},
      accordianTabpickup:{1:false, 2:false},
      expanded:false,
      pickupexpanded:false,
      startTrip:false,
      isLoading:false,
      srUser: '',
      ContractedVehicle: null,
      AdHocVehicle: false,
      VehicleModel: null,
      wheeler: '',
      adHocVehicleNumber: '',
      srUserList: [],
      VehicleModellist: [],
      ContractedVehiclelist: [],
      VehicleModelitem:{value:'',text:''},
      selectedUser:{value:'',text:''},
      ContractedVehicleitem:{value:'',text:''},
      HubId: '',
      HubName: '',
      srUserId: null,
      srUserEmail: '',
      srUserErr: '',
      vehicleErr:'',
      tripID: '',
      tmstripid: '',
      showAddShipment:false,
      userType:'',
      addShipmentTabErr: '',
      addpickuprequesterr:'',
      assignedLoad: 0,
      AvailaibleCapacity: 0,
      VehicleName: '',
      VehicleCapacity: 0,
      parentData: {},
      tripData:'',
      VehicleType: '',
      isAWBAllocated: false,
      vehicleModelErr:'',
      WheelErr: '',
      vehicleNoErr: '',
      tripStatus: this.parentObj.tripstatus,
      allocationData: '',
      hubsetting:'',
      scantype:'',
      allocationtypewt: '',
      assignedLoadfm: 0,
      assignedLoadlm: 0,
      companyNamelist:[],
      AddedClientName:null,
      AddedClientNametemp:null,
      offset: 0,
      offset2:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      totalCount:0,
      tableItems:[],
      totalPage2:0,
      totalPage: 0,
      pageLimit2:CONSTANT.PER_PAGE_DATA,
      totalCount2:0,
      tableItems2:[],
      pickupFromDate:'',
      pickupToDate:'',
      pickupPincode:'',
      isAllSelected:false,
      selectedAWBCount:0,
      selectedRequest:[],
      Pincodelist:'',
      tempPincode:'',
      isAllAddedSelected:false,
      selectedRemoveRequest: [],
      currentPage:1,
      currentPage2:1,
      requesterr:'',
      removerequesterr:'',
      PICKUPREQUEST:'',
      pickuprequest:'',
      srHelperList: [],
      srHelperId: null,
      srHelperErr: '',
      isHelper:false,
      selectedhelper: {},
      disablehelper: true,
      showRouteSelection: false,
      showAllocationModal: false,
      routeDetailsList: [],
      selectedroute: [],
      allocationstatus: "In Progress",
      vehicleweght: 50,
      allocatedweight: 0,
      allocatedawb: [],
      allocatedlist: [],
      notautoallocated:[],
      forcestop: false,
      forcestopBtn: false,
      showNotallocated: false,
      savebookingallocationflag: false,
      selectedBookingQueue: [],
      allocatedToTrip:[],
      currentroute:[],
      currentrouteindex:0,
      loaderFlag:false,
      saveallocationflag:false,
      testallotedawb: [],
      testremovedawb:[],
      testweight:[],
      allocationstopmessage:"",
      cutoffweight: -0.20,
      getawblimit: 10,
      autoallocatepocflag:true,
      userrole:'',
      srdisabled:false,
      allocatedweightfm: 0,
      allocatedweightlm: 0,
      assignedLoadfm: 0,
      assignedLoadlm: 0,
      allocatedToTripFm:[],
      allocatedToTripLm:[],
      openpickupdeliveryclients:'',
	  marketvehiclereqflag:false,
	  vehiclerequestid:'',
	  adHocVehicleCost:null,
	  updateflag:false,
	  updateAdHocVehicleflag:false,
	  updateAdhocVehicleCost:false,
	  marketVehicle:'',
	  usertripcreation:false,
      emptype: ['TSP BA', 'StoreSR', 'TSP First Mile BA', 'TSP Last Mile BA', 'OutsourceSR'],
      visibleWarningMessage: false,
      podPendencyWarningMessage: "",
      restrictSrFromTripCreation: false,
      viewPendencyWarningIcon: false,
      restrictUserid: 0,
      approvalconfiguredhub:false,
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    // this.defaultHubID = userdetail.hubID;
    this.HubId = userdetail.hubID[0];
    this.HubName = userdetail.currentHubName;
    this.userrole = userdetail.rolename[0]
    this.getCompanyShortName();
	this.checkMarketVehicleConfiguredHub();
    // this.HubId = 24;
    await this.getSRListing()
    if( this.userrole == 'TSP BA Admin'){
      let results = this.srUserList.filter(function (entry) { return entry.olddelveryuseroruserid == userdetail.vendorid; });
      this.srUserId = results[0].id
      this.srUser = results[0].label
      this.srUserEmail = results[0].sremail ? results[0].sremail : this.srUser
      this.userType = results[0].emptype
      this.srdisabled = true
      this.getSRHelperListing();
      this.disablehelper = false
    }
    this.getAutoAllocationconfig();
    await this.getContractedVehicleList()
    await this.getVehicleModel()
    await this.getOpenPickupDeliveryClients();
    await this.getPickupListForTrip()
	if(this.parentObj && this.parentObj.marketvehiclereqflag){
		this.updateflag = true
		this.marketvehiclereqflag = true;
		this.vehiclerequestid = this.parentObj.requestid
		this.AdHocVehicle = true;
		this.updateAdHocVehicleflag = true;
		this.VehicleName = this.parentObj.approvedvehicletype
		this.HubName = this.parentObj.hubname
		this.HubId = this.parentObj.hubid
		if(this.parentObj.vehiclenumber){
			this.adHocVehicleNumber = this.parentObj.vehiclenumber
		}
        this.wheeler = this.parentObj.wheeler
		this.adHocVehicleCost = this.parentObj.approvedvehiclecost
		this.preFillMarketVehicleData(this.parentObj.approvedvehicletype);
	}
    if(this.parentObj && this.parentObj.tripId){
      this.tripID = this.parentObj.tripId
      await this.getTripData()
      this.getAvilableroute()
      this.$nextTick(() => {
        this.showAddShipment	= true
      })
    }else{
      this.$nextTick(() => {
        this.showAddShipment	= true
      })
    }
    await this.AddedToTripRequest()
  },
  created() {
    this.$root.$refs.createTripManagement = this;
  },
  methods: {
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getTripData(){
      try {
        this.tripData = ''
        this.isLoading = true
        let InputPayload = {
          tripid: this.tripID
        };
        let result = await TripServices.getTripData(InputPayload);
        this.tripData = result.data.data.result;
        this.tmstripid = this.tripData.tmstripid
        this.tripStatus = this.tripData.tripstatus
        this.hubsetting = result.data.data.hubsetting;
		this.vehiclerequestid = this.tripData.adhocvehiclerequestid
		this.adHocVehicleCost = this.tripData.adhocvehiclecost
        this.scantype = this.hubsetting.scantype
        this.preFillSRData()
        this.preFillHelperData()
        this.preFillVehicleData()
        this.allocationData = {
          tripID: this.tripID,
          tripStatus: this.tripStatus,
          istripDTH: this.tripData.isdth
        }
        this.showAddShipment	= true
        this.isLoading = false
      } catch (err) {
        console.log(err);
      }
    },
    async showPodPendencyWarning() {
      let inputPayload = {
        hubid: [this.HubId],
        userid:this.restrictUserid ? parseInt(this.restrictUserid):parseInt(this.srUserId)
      }
      let podPendencyData = await TripServices.fetchSrPodPendancyDetails(inputPayload)
      if (podPendencyData && podPendencyData.data.code != 200) {
        if (podPendencyData && podPendencyData.data.code == 201) {
          this.visibleWarningMessage = true
          this.podPendencyWarningMessage = podPendencyData.data.data.webmessage
          this.restrictSrFromTripCreation = false
          
        } else if(podPendencyData && podPendencyData.data.code == 204) {
          this.visibleWarningMessage = false
          this.podPendencyWarningMessage = podPendencyData.data.data.webmessage
          this.restrictSrFromTripCreation = true
        } else {
          this.restrictSrFromTripCreation = false
          this.visibleWarningMessage = false
        }
      } else {
        this.restrictSrFromTripCreation = false
        this.podPendencyWarningMessage=""
          this.visibleWarningMessage = false
      }
      
    },
    preFillSRData(){
      this.srUserId = this.tripData.userid
      this.srUserList.map(obj => {
        if(obj.id == this.tripData.userid){
          this.srUser = obj.label
          this.userType = obj.emptype
		  this.usertripcreation = true
        }
      })
    },
    async preFillHelperData() {
      await this.getSRHelperListing();
      this.disablehelper= false
      if (this.tripData.helper) {
        this.srHelperId =[]
        for (const key in this.tripData.helper) {
          if (this.tripData.helper.hasOwnProperty(key)) {
            const element = this.tripData.helper[key];
            let helpersr = {}
            this.srHelperList.forEach(item => {
              if (item.id == element.id) {
                this.srHelperId.push(item)
              }
            })
          }
        }
      }
    },
    setTripData(){
      this.showAddShipment	= false;
      this.getTripData();
    },

	async preFillMarketVehicleData(vehiclemodel){
		this.VehicleType = 'market'
		  this.VehicleModellist.map(obj => {
			if(obj.label ==  vehiclemodel){
				this.VehicleModel = obj.id
				this.VehicleCapacity = obj.capacity
			}
		  })
	  },

    preFillVehicleData(){
      this.VehicleType = this.tripData.vehicletype
      if(this.VehicleType == 'market'){
        this.AdHocVehicle = true
        this.VehicleName = this.tripData.vehiclevendortype
        this.adHocVehicleNumber = this.tripData.vehiclenumber
        this.wheeler = this.tripData.vehiclewheel
        this.VehicleModellist.map(obj => {
          if(obj.label == this.tripData.vehiclevendortype){
            this.VehicleModel = obj.id
            this.VehicleCapacity = obj.capacity
          }
        })
        this.AvailaibleCapacity =  Number(this.VehicleCapacity) - Number(this.assignedLoad)
      }else{
        let vendorvehicleid
        if(this.ContractedVehiclelist.length == 0) {
           this.getContractedVehicleList()
        }
        this.ContractedVehiclelist.map(obj => {
          if(obj.label == `${this.tripData.vehiclenumber} (${this.tripData.vehiclevendortype})`){
            vendorvehicleid = obj.id
            this.vehicleName = obj.vehiclename
            this.vehicleVendorName = obj.VendorName
            this.VehicleCapacity = obj.capacity.toFixed(2)
          }
        })
        this.vehicleNumber = this.tripData.vehiclenumber
        this.ContractedVehicle = vendorvehicleid
        this.AvailaibleCapacity =  Number(this.VehicleCapacity) - Number(this.assignedLoad)
      }
    },

    async getSRListing() {
      try {
        this.srUserList = []
        let InputPayload = {
          HubId: [this.HubId]
        };
        let result = await TripServices.getSRList(InputPayload);
        let SRList = await result.data.data;
          SRList.forEach(item=>{
            this.srUserList.push({
              id:item.userid,
              label:`${item.srname} (${item.userid})`,
              sremail:item.email,
              emptype:item.emptype,
              olddelveryuseroruserid:item.olddelveryuseroruserid,
              isDisabled: item.disable
            })
          })
      } catch (err) {
        console.log(err);
      }
    },

    async getSRHelperListing() {
      try {
        this.srHelperList = []
        let InputPayload = {
          HubId: [this.HubId],
          userid: this.srUserId
        };
        let result = await TripServices.getSRHelperList(InputPayload);
        let HelperList = await result.data.data;
        HelperList.forEach(item=>{
            this.srHelperList.push({
              id:item.userid,
              label:`${item.srname} (${item.userid})`,
              sremail:item.email,
              emptype:item.emptype,
              name: item.srname,
              isDisabled: item.disable
            })
          })
      } catch (err) {
        console.log(err);
      }
    },

    async getContractedVehicleList() {
      try {
        let InputPayload = {
          HubId: this.HubId
        };
        let result = await TripServices.getVehiclelist(InputPayload);
        let vehiclelist = result.data.data;
        for (var i = 0; i < vehiclelist.length; i++) {
          this.ContractedVehiclelist.push({
            'id': vehiclelist[i].VendorVehicleId,
            'label': `${vehiclelist[i].VehicleNumber} (${vehiclelist[i].VehicleName})`,
            'vehiclenumber': vehiclelist[i].VehicleNumber,
            'capacity': vehiclelist[i].VehicleCapacity,
            'vehiclename': vehiclelist[i].VehicleName,
            'vehicletype': 'vehicle',
            'VendorName': vehiclelist[i].VendorName,
            'isDisabled': vehiclelist[i].disable
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getVehicleModel() {
      try {
        this.isLoading = true
        let result = await TripServices.getVehicleType();
        let vehicletype = result.data.data;
        for (var i = 0; i < vehicletype.length; i++) {
          this.VehicleModellist.push({
            'id': vehicletype[i].VehicleId,
            'label': vehicletype[i].VehicleName,
            "capacity": vehicletype[i].Capacity
          });
        }
        this.isLoading = false
      } catch (err) {
        console.log(err);
      }
    },

    selectSRUser(user) {
    this.restrictUserid = user.id
    this.showPodPendencyWarning()
	  if(this.parentObj && this.parentObj.marketvehiclereqflag){
		this.srUserErr = ''
		this.srUser = user.label
		this.srUserId = user.id
		this.srUserEmail = user.sremail
		this.userType = user.emptype
		this.getSRHelperListing();
		this.disablehelper = false;
		if(!this.emptype.includes(user.emptype)){
			this.usertripcreation = true
		}else{
			this.usertripcreation = false
		}
	  } else{
		this.srUserErr = ''
		this.srUser = user.label
		this.srUserId = user.id
		this.srUserEmail = user.sremail
		this.userType = user.emptype
		this.getSRHelperListing();
		this.disablehelper = false;
		if(this.emptype.includes(user.emptype) ){
		  this.usertripcreation = true
		  this.AdHocVehicle = true
		  this.clearDataForAdHocVehicle();
		}else{
		  this.AdHocVehicle = false
		  this.clearDataForAdHocVehicle();
		  this.usertripcreation = false
		}
	  }
    },
	selectSRUserKeyUp(user) {
		if (!user) {
		  this.disablehelper = true;
		  this.isHelper = false;
		  this.srHelperId = null;
		} else {
		  this.isHelper = false;
		  this.srHelperId = null;
		}
	},	
	async checkMarketVehicleConfiguredHub(){
		try {
			this.isLoading = true
			let inputPayload ={
				hubid:this.HubId
			}
			let result = await TripServices.getApprovalConfiguredHub(inputPayload);
			this.isLoading = false
			if(result.data.code==200){
				this.approvalconfiguredhub = true
			}
		}catch(err){
			console.log(err);
		}	
    },
    selectSRHelper(user){
      this.selectedhelper[user.id] = user;
      this.selectedhelper[user.id].id = Number(user.id);
      this.selectedhelper[user.id].status = 2;
    },

    selectedContractedVehicle(vehicle){
      this.vehicleErr = ''
      this.ContractedVehicle = vehicle.id,
      this.vehicleNumber = vehicle.vehiclenumber
      this.vehicleName = vehicle.vehiclename,
      this.VehicleType = vehicle.vehicletype
      this.vehicleVendorName = vehicle.VendorName
      this.VehicleCapacity = vehicle.capacity.toFixed(2)
      this.AvailaibleCapacity =  Number(this.VehicleCapacity) - Number(this.assignedLoad)
    },
    selectedVehicleModel(vehicletype){
      this.VehicleModel = vehicletype.id
      this.VehicleName = vehicletype.label
      this.VehicleCapacity = vehicletype.capacity.toFixed(2)
      this.VehicleType = 'market'
      this.AvailaibleCapacity =  Number(this.VehicleCapacity) - Number(this.assignedLoad)
    },
    ShowStartTrip() {
      if(this.checkErr()){
        return false
      }
      this.parentData = {
        tripID: this.tripID,
        vehicleNumber: this.AdHocVehicle?this.adHocVehicleNumber:this.vehicleNumber,
        vehicleFlag:this.AdHocVehicle?true:false,
        srUser: this.srUser,
        srUserId: this.srUserId,
        tmstripid: this.tmstripid,
        hubid: this.HubId,
        hubname: this.HubName,
        vehicletype: this.VehicleType,
        vehiclevendorid: this.ContractedVehicle,
        tripstatus: this.tripStatus,
        userType:this.userType,
        scantype: this.scantype,
        vehiclecapacity: this.VehicleCapacity
      }
      this.startTrip =true;
    },
    callParent() {
        this.startTrip = false;
        this.showAddShipment	= false
        this.getTripData()
    },
    showTripMgmt() {
      this.clearEditField()
      this.$emit("goBackToParent")
    },

    clearEditField(){
      this.tripData = '';
      this.tmstripid = ''
      this.srUserId = null
      this.srUser = ''
      this.VehicleType = ''
      this.AdHocVehicle = false
      this.VehicleName = ''
      this.VehicleModel = null
      this.VehicleCapacity = ''
      this.AvailaibleCapacity = ''
      this.vehicleVendorName = ''
      this.vehicleNumber = ''
      this.adHocVehicleNumber = ''
      this.ContractedVehicle = null
      this.userType = ''
    },
    pickupexpandAll() {
      this.pickupexpanded = true;
      for (var key in this.accordianTabpickup) {
        this.accordianTabpickup[key] = true;
      }
    },
    pickupcollapseAll() {
      this.pickupexpanded = false;
      for (var key in this.accordianTabpickup) {
        this.accordianTabpickup[key] = false;
      }
    },
    expandAll(){
      this.expanded = true;
      this.addShipmentTabErr = ''
      this.addpickuprequesterr = ''
      for (var key in this.accordianTab) {
        if(key == 3 && (!this.tripID)){
          this.accordianTab[3] = false
          this.addShipmentTabErr = !this.tripID?'Trip Not Created':'Trip Already Started'
        }
        if(key == 4 && (!this.tripID)){
          this.accordianTab[4] = false
          this.addpickuprequesterr = !this.tripID?'Trip Not Created':''
        }else{
          this.accordianTab[key] = true;
        }
      }
    },
    collapseAll(){
      this.expanded = false;
      this.addShipmentTabErr = ''
      this.addpickuprequesterr = ''
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    PickuptoggleCheck(tabid) {
      this.expanded = false;
      for (var key in this.accordianTabpickup) {
        if (tabid != key) {
          this.accordianTabpickup[key] = false;
        }
      }
    },
    toggleCheck(tabid){
      this.addShipmentTabErr = ''
      this.addpickuprequesterr = ''
      if(tabid == 3 && (!this.tripID)){
          if(this.expanded == false){
            this.expanded = false;
          }else{
            this.expanded = true;
          }
        this.accordianTab[3] = false
        this.addShipmentTabErr = !this.tripID?'Trip Not Created':'Trip Already Started'
        return false
      }
      if(tabid == 4 && (!this.tripID)){
        if(this.expanded == false){
          this.expanded = false;
        }else{
          this.expanded = true;
        }
      this.accordianTab[4] = false
      this.addpickuprequesterr = !this.tripID?'Trip Not Created':''
      return false
    }
      this.expanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.accordianTab[key] = false;
        }
      }
    },

    async createTrip(){
      try{
        if(this.checkErr()){
          return false
        }
        this.isLoading = true
        let input = {
          "sruserid" : Number(this.srUserId) ,
          "srusername" : this.srUser ,
          "sruseremail" : this.srUserEmail?this.srUserEmail:this.srUser,
          "srusertype": this.userType,
          "hubid": this.HubId ,
          "lastmodifiedby":this.userName,
          "hubname":this.HubName,
          "tripstate": 'created',
          "ishelper" : this.srHelperId && this.srHelperId.length >0 ? 1 : 0,
		  "vehiclecost": this.adHocVehicleCost,
		  'vehiclerequestid': this.vehiclerequestid
        }
        if(this.AdHocVehicle){
          input.vehicleno = this.adHocVehicleNumber
          input.vehiclename = this.VehicleName
          input.vehiclewheel= this.wheeler
          // input.vehiclevendorid = ''
          input.vehiclevendorname =  ''
          input.vehicletype = this.VehicleType
          input.vehiclecapacity = this.VehicleCapacity.toString();
        } else{
          input.vehicleno = this.vehicleNumber
          input.vehiclename = this.vehicleName
          input.vehiclevendorid = this.ContractedVehicle
          input.vehiclevendorname =  this.vehicleVendorName
          input.vehicletype = this.VehicleType
          input.vehiclecapacity = this.VehicleCapacity
        } if ( this.srHelperId && this.srHelperId.length ) {
          let helperpayload = {}
          this.srHelperId.forEach(item => {
            helperpayload[item.id] = {
              id: item.id,
              name: item.name,
              email: item.sremail,
              status: 2,
              usertype: item.emptype
            }
            this.isHelper = true
          });
          input.helpersr = helperpayload
        }
        let result = await TripServices.createTrip(input);
        this.isLoading = false
        if(result.data.code == 200){
          this.tmstripid = result.data.data.tmstripid
          this.tripID = result.data.data.tripid
          this.tripStatus = 'created'
          this.parentData = {
            tripID: this.tripID,
            vehicleNumber: this.AdHocVehicle?this.adHocVehicleNumber:this.vehicleNumber
          }
          this.allocationData = {
            tripID: this.tripID,
            tripStatus: this.tripStatus,
            istripDTH: 0
          }
          this.showAddShipment = false
          this.showAddShipment = true
          this.$alert(result.data.message, "", "success");
          this.accordianTab[3] = true
          this.toggleCheck(3)
          await this.getAvilableroute();
          // this.srroutemapping()
          if( this.userrole != 'TSP BA Admin'){
            this.showRouteModal();
          }
          await this.getTripData()
        }else{
          this.$alert(result.data.message, "", "error");
        }
      } catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },

    checkErr() {
      let err = 0
      if(!this.srUserId){
        this.srUserErr = 'Please Select User/SR'
        err = 1
      }
      if(this.AdHocVehicle){
		if(this.approvalconfiguredhub){
			if(!this.usertripcreation && !this.marketvehiclereqflag){
				this.srUserErr = `${this.userType} Role user is not authorised to create trip for Adhoc Vehicle without Approval`
				err = 1
			}else if(!this.usertripcreation && this.marketvehiclereqflag){
				this.srUserErr = `${this.userType} Role user is not applicable for the process`
				err = 1
			}else{
				this.srUserErr = ''
			}
		}
        if(!this.VehicleModel){
          this.vehicleModelErr = 'Please Select Vehicle Model'
          err = 1
        }else{
          this.vehicleModelErr = ''
        }
        if(!this.wheeler){
          this.WheelErr = 'Please Select Vehicle Type'
          err = 1
        }else{
          this.WheelErr = ''
        }
        if(!this.adHocVehicleNumber){
          this.vehicleNoErr = 'Please Enter Vehicle Number'
          err = 1
        }else{
          if (!this.adHocVehicleNumber.trim().match(/^[A-Z]{2}[ ]?[0-9]{2}[ ]?[A-Z]{1,2}[ ]?[0-9]{4}$/))
          {
            this.vehicleNoErr = 'Vehicle Number Format Is Incorrect'
            err = 1
          }else{
            this.vehicleNoErr = ''
          }
          this.ContractedVehiclelist.forEach(item=>{
            if(item.vehiclenumber==this.adHocVehicleNumber){
              err=1
              this.vehicleNoErr = 'Vehicle Number Already Exists In Contracted Vehicle'
            }
          })
        }
      }else{
        if(!this.ContractedVehicle){
          this.vehicleErr = 'Please Select Vehicle'
          err = 1
        }else{
          this.vehicleErr = ''
        }
      }
      return err
    },
    
    async checkRestrictionErr(tripStatus) {  
      let err = 0  
      await this.showPodPendencyWarning()
     if (this.visibleWarningMessage) {
        let messageString = `
       <br><i class="fa fa-exclamation-circle fa-4x" aria-hidden="true" style="color: #5490e9;"></i><br><br>
        <p style="font-size:18px">${this.podPendencyWarningMessage}</p>         
        `
          this.$fire({
            icon: "success",
             html: messageString,
             width: 500,
             textalign: 'center',          
             reverseButtons: true,
             showCancelButton: true,
             cancelButtonColor: '#20a8d8',
             confirmButtonColor: '#009C41',
             confirmButtonText: '<i class="fa fa-thumbs-up"></i> View Pendency List',
             cancelButtonText: '<i class="fa fa-times-circle-o"></i> Close',         
          }).then((result) => {
               if (result.value == true) {
				let query = {
					userid : this.srUserId
				}
				const queryString = new URLSearchParams(query).toString();
				const url = `#/poduploadpendency?${queryString}`;
				window.open(url, '_blank');
               } else {
                 if (tripStatus == 'create') {
                 this.createTrip()
                 }
                 if (tripStatus == 'start') {
                   this.ShowStartTrip()
                 }
                }
             }).catch((err)=>{
              console.log(err)
            }); 
        err = 0
      }else if (this.restrictSrFromTripCreation) {
        let messageString = `
       <br><i class="fa fa-times-circle fa-4x" aria-hidden="true" style="color: #ef2814;"></i><br><br>
        <p style="font-size:18px">You cannot ${tripStatus} a trip because there are pending PODs (Proof of Delivery) that need to be uploaded. Please upload all pending PODs to proceed with trip creation/start.</p> 
        `
          this.$fire({
            icon: "success",
             html: messageString,
             width: 500,
             textalign: 'center',          
             reverseButtons: true,
             showCancelButton: true,
             cancelButtonColor: '#20a8d8',
             confirmButtonColor: '#009C41',
             confirmButtonText: '<i class="fa fa-thumbs-up"></i> View Pendency List',
             cancelButtonText: '<i class="fa fa-times-circle-o"></i> Close',         
             }).then((result) => {
               if (result.value == true) {
				let query = {
					userid : this.srUserId
				}
				const queryString = new URLSearchParams(query).toString();
				const url = `#/poduploadpendency?${queryString}`;
				window.open(url, '_blank');
               }
             }).catch((err)=>{
              console.log(err)
            }); 
        err = 1
      } else {
        if (tripStatus == 'create') {
          this.createTrip()
          }
          if (tripStatus == 'start') {
            this.ShowStartTrip()
          }
      }
      return err
    },
    updateAssignedLoad(data,isAWBAssigned, individualWeight){
      this.assignedLoad = data
      this.AvailaibleCapacity =  Number(this.VehicleCapacity) - Number(this.assignedLoad)
      this.isAWBAllocated = isAWBAssigned
      this.assignedLoadfm = Number(individualWeight.fmweight)
      this.assignedLoadlm = Number(individualWeight.lmweight)
    },

    clearDataForAdHocVehicle(){
      if(this.AdHocVehicle){
        this.ContractedVehicle = null,
        this.vehicleNumber = ''
        this.vehicleName = '',
        this.VehicleType = ''
        this.vehicleVendorName = ''
        this.VehicleCapacity = 0
        this.AvailaibleCapacity = 0
        this.vehicleErr = ''
        this.wheeler = '4'
      }else{
        this.adHocVehicleNumber = ''
        this.VehicleName = ''
        this.VehicleModel = null
        this.wheeler = ''
        this.VehicleCapacity = 0
        this.AvailaibleCapacity = 0
        this.vehicleModelErr = ''
        this.WheelErr = ''
        this.vehicleNoErr = ''
		this.srUserErr = ''
      }
    },

    async getPickupListForTrip(){
      try{
        this.isLoading = true
        this.tableItems = []
        this.totalCount = 0
        let payload = {
          hubid: this.HubId,
          offset: this.offset,
          limit: this.pageLimit
        }
        if(this.AddedClientName){
          payload.clientid = this.AddedClientName
        }
        if(this.pickupPincode){
          payload.pickuppincode = this.pickupPincode
        }
        if(this.pickupFromDate){
          payload.pickupfromdate = this.pickupFromDate
        }
        if(this.pickupToDate){
          payload.pickuptodate = this.pickupToDate
        }
        if(this.pickuprequest){
          payload.pickuprequest = this.pickuprequest
        }
        let result = await TripServices.getPickupListForTrip(payload)
        if(result.data.code == 200){
          this.tableArr = result.data.data.rows;
          this.totalCount = Number(result.data.data.count);
          if(this.totalCount>0){
            this.tableItems = result.data.data.rows.map((el)=>{
              return {
                'ID':el.id,
                'ClientName':el.clientname,
                'ClientID':el.clientid,
                'PickupAddress':el.pickupaddress,
                'PickupPincode':el.pickuppincode,
                'NumberofMPS':el.numberofmps,
                'PickupWeights': el.totalwt,
                'RequestCreationDate': Util.displayDateTimeFormat(el.createddate),
                'RequestPickupDate': el.requestedpickupdate,
                'Rescheduleddate': el.rescheduleddate?Util.displayDateOnlyFormat(el.rescheduleddate): el.rescheduleddate,
                'disable' : el.disable ? el.disable : 0,
                'disablereason' : el.disablereason ? el.disablereason : "",
                'isopenpickupdelivery': this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`] ? this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`][`${el.routemode}`] ? 1 : 0 : 0,
              }
            })
          }else{
            this.tableItems = [];
          }
        }
          if (this.totalCount < this.pageLimit) {
            this.totalPage = 1
          } else {
            this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
          }
        this.isLoading = false
      }catch(err){
        this.isLoading = false
        console.log(err)
      }
    },

    async AddedToTripRequest(){
      try{
        this.isLoading = true
        this.tableItems2 = []
        this.totalCount2 = 0
        let payload = {
          tripid: this.tripID,
          offset: this.offset2,
          limit: this.pageLimit
        }
        if(this.AddedClientNametemp){
          payload.clientid = this.AddedClientNametemp
        }
        if(this.pickupPincode){
          payload.pickuppincode = this.pickupPincode
        }
        if(this.PICKUPREQUEST){
          payload.pickuprequest = this.PICKUPREQUEST
        }
        let result = await TripServices.AddedToTripRequest(payload)
        if(result.data.code == 200){
          this.tableArr2 = result.data.data.rows;
          this.totalCount2 = Number(result.data.data.count);
          if(this.totalCount2>0){
            this.tableItems2 = result.data.data.rows.map((el)=>{
              return {
                'ID':el.id,
                'ClientName':el.clientname,
                'ClientID':el.clientid,
                'PickupAddress':el.pickupaddress,
                'PickupPincode':el.pickuppincode,
                'NumberofMPS':el.numberofmps,
                'PickupWeights': el.totalwt,
                'RequestCreationDate': Util.displayDateTimeFormat(el.createddate),
                'RequestPickupDate': el.requestedpickupdate,
                'isopenpickupdelivery': this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`] ? this.openpickupdeliveryclients[`${el.clientbusinessaccountid}`][`${el.routemode}`] ? 1 : 0 : 0,
                // 'Action': 'Print'
              }
            })
          }else{
            this.tableItems2 = [];
          }
        }
          if (this.totalCount2 < this.pageLimit2) {
            this.totalPage2 = 1
          } else {
            this.totalPage2 = Math.ceil(this.totalCount2 / this.pageLimit2);
          }
        this.isLoading = false
      }catch(err){
        this.isLoading = false
        console.log(err)
      }
    },
    select(){
      if(this.isAllSelected){
        this.isAllSelected=0
      }
    },
    selectAll() {
      if (this.isAllSelected) {
        this.tableItems.forEach(item => {
            if (this.selectedRequest.some(el => el.ID == item.ID) || item.disable == 1) {
              return
            } else {
              this.selectedRequest.push(item)
            }
        })
      }else{
        this.selectedRequest=this.selectedRequest.filter(item=>{
          if(this.tableItems.some(el=>el.ID==item.ID)){
            return false
          }else{
            return true
          }
        })
      }
    },
    selectRemove() {
      if (this.isAllAddedSelected) {
        this.isAllAddedSelected = 0
      }
    },
    selectAllAdded() {
      if (this.isAllAddedSelected) {
        this.tableItems2.forEach(item => {
          if (this.selectedRemoveRequest.some(el => el.ID == item.ID)) {
            return
          } else {
            this.selectedRemoveRequest.push(item)
          }
        })
      } else {
        this.selectedRemoveRequest = this.selectedRemoveRequest.filter(item => {
          if (this.selectedRemoveRequest.some(el => el.ID == item.ID)) {
            return false
          } else {
            return true
          }
        })
      }
    },
    onPageChange(page) {
      this.isAllSelected=false;
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getOpenPickupDeliveryClients();
      this.getPickupListForTrip();
    },
    onPageChange2(page){
      this.isAllAddedSelected = false;
      this.currentPage2 = page;
      this.offset2 = (page - 1) * this.pageLimit2
      this.AddedToTripRequest();
    },
    reset(){
      this.PICKUPREQUEST = ''
      this.AddedClientNametemp = null
      this.onPageChange2(1)
      },

    resetFilter(){
      this.pickuprequest = ''
      this.pickupPincode = '',
      this.pickupFromDate = '',
      this.pickupToDate = '',
      this.AddedClientName = null,
      this.onPageChange(1)
      },
      async addRequestToTrip(){
        try{
          if(this.selectedRequest.length == 0){
            this.requesterr = "Please Select Atleast One Request";
            return false
          }
          this.isLoading = true;
          let finalarr = this.selectedRequest.map(obj=>{
              let temp = {
                tripid: this.tripID,
                requestid: obj.ID,
                clientid: obj.ClientID,
                clientname:obj.ClientName,
                pickupaddress:obj.PickupAddress,
                pickuppincode:obj.PickupPincode,
                numberofmps:obj.NumberofMPS,
                physicalweight:obj.PickupWeights
              }
            return temp
          })

          let payload = {
            requestarray: finalarr,
            lastmodifiedby: this.userName
          }
          let result = await TripServices.AllocateRequestToTrip(payload)
          this.isLoading = false;
          if(result.data.code == 200){
            let success = [];
            let failure = [];
            result.data.data.forEach(item=>{
              if(item.code==200){
                success.push(item);
              }else{
                failure.push(item)
              }
            });
            if(success.length>0){
              this.$alertify.success(result.data.message);
            }
            failure.forEach(item=>{
              this.$alertify.error(item.message);
            })
            this.isAllSelected = false;
            this.selectedRequest = []
            this.offset2 = 0
            this.offset = 0
            this.getPickupListForTrip()
            this.getOpenPickupDeliveryClients();
            await this.AddedToTripRequest()
          }
          else {
            this.isAllSelected = false;
            this.selectedRequest = []
            this.offset2 = 0
            this.offset = 0
            this.getPickupListForTrip()
            this.getOpenPickupDeliveryClients();
            await this.AddedToTripRequest()
            this.$alert(result.data.message, "", "error");
          }
        }catch(err){
          console.log(err)
        }
      },

    async removeFromTrip(){
      try{
        if(this.selectedRemoveRequest.length == 0){
          this.removerequesterr = "Please Select Atleast One Request";
          return false
        }
        this.isLoading = true;
        this.removeawberr = ''
        let finalArr = this.selectedRemoveRequest.map(obj => {
          let temp = {
            'requestid':obj.ID
          }
          return temp
        })
        let input = {
          rejectedarray: finalArr,
          lastmodifiedby:this.userName
        }
        let result = await TripServices.RemoveRequestFromTrip(input);
        this.isLoading = false
        if(result.data.code == 200){
          this.$alert("Request Remove Successfully", "", "success");
          this.isAllAddedSelected = false;
          this.offset2 = 0
          this.offset = 0
          this.selectedRemoveRequest = []
          this.getPickupListForTrip()
         await this.AddedToTripRequest()
        }
        else{
          this.$alert(result.data.message, "", "error");
        }
      }catch(err){
        console.log(err)
      }
    },
    isIntegerOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    showRouteModal() {
      if (this.routeDetailsList.length == 0) {
        this.autoallocatepocflag=false;
      } else {
        this.autoallocatepocflag=true;
        let weightPercentage = (Number(this.VehicleCapacity) - Number(this.allocatedweight))/Number(this.VehicleCapacity)
        let weightPercentagefm = (Number(this.VehicleCapacity) - Number(this.allocatedweightfm))/Number(this.VehicleCapacity)
        let weightPercentagelm = (Number(this.VehicleCapacity) - Number(this.allocatedweightlm))/Number(this.VehicleCapacity)
        if (((weightPercentagefm > this.cutoffweight) || (weightPercentagelm > this.cutoffweight)) && this.routeDetailsList.length > 0 && this.tripStatus != 'closed' && this.tripStatus != 'start') {
          this.showRouteSelection = !this.showRouteSelection;
          this.parentObj.autoallocate = true;
        } else if(this.tripStatus == 'closed') {
          this.parentObj.autoallocate = false;
          this.$alertify.error("Trip is already closed.");
        } else if(this.tripStatus == 'start') {
          this.parentObj.autoallocate = false;
          this.$alertify.error("Trip is already started.");
        }else if((weightPercentagefm <= this.cutoffweight) && (weightPercentagelm <= this.cutoffweight) ) {
          this.parentObj.autoallocate = false;
          this.$alertify.error("Vehicle Capacity is full.");
        }
      }
    },
    selectroutename(item) {
      this.routeDetailsList.push(item)
      let tempAvilable =[]
      this.selectedroute.forEach((obj) => {
        if (item.id != obj.id) {
          tempAvilable.push(obj)
        }
      });
      this.selectedroute = tempAvilable;
    },
    routeSelect(event, item) {
      if (event.target.checked) {
        this.selectedroute.push(item)
      } else {
        let tempAvilable =[]
        this.selectedroute.forEach((obj) => {
          if (item.id != obj.id) {
            tempAvilable.push(obj)
          }
        });
        this.selectedroute = tempAvilable
      }
      for (let index = 0; index < this.routeDetailsList.length; index++) {
        if (item.id == this.routeDetailsList[index].id ) {
          this.routeDetailsList[index].selected = !this.routeDetailsList[index].selected
        }
      }

    },
    openAllocation() {
      this.showRouteSelection = false;
      this.showAllocationModal = true;
      this.startAutoAllocation()
    },
    async startAutoAllocation() {
      this.loaderFlag = true;
      this.allocatedweight = Number(this.assignedLoad)
      this.allocatedweightfm = Number(this.assignedLoadfm);
      this.allocatedweightlm = Number(this.assignedLoadlm);
      this.allocationstatus = "In Progress"
      this.currentrouteindex = 0
      this.notautoallocated=[]
      // Loop to iterate routes
      for(let i =0 ; i <this.selectedroute.length; i++) {
        this.currentrouteindex =i
        // Loop to iterate routes priority
        if(!this.allocatedToTrip[i]){
          this.allocatedToTrip[i] = []
          this.allocatedToTripFm[i] = []
          this.allocatedToTripLm[i] = []
        }
        if (i>0) {
          this.$set(this.currentroute, i-1 , 'Completed');
        }
        this.$set(this.currentroute, i , 'Allocation In Progress');

        for (let j = 0; j < this.selectedroute[i].routedetails.length; j++) {
          let obj = this.selectedroute[i].routedetails[j]
          let clientid = 0
          let altype= ""
          let pincode="";
          let clientbusinessaccountid=0;
          // if client id is present in priority
          if (obj.clientid && obj.clientid !== 0) {
            clientid = obj.clientid
          }
          // if FM and LM pincodes are present in priority
          if (obj.shipmenttype != 0) {
            if (obj.shipmenttype != 0) {
              if (obj.pincode && obj.pincode != 0 && obj.shipmenttype == 1) {
                altype = 'FirstMile';
                pincode = ""+obj.pincode;
              } else if (obj.pincode && obj.pincode != 0 && obj.shipmenttype == 2) {
                altype = 'LastMile';
                pincode = ""+obj.pincode
              }
            }
            await this.getAWBForAutoAllocation(i, this.selectedroute[i].id, this.selectedroute[i].routename, clientid, altype, pincode, 1)
            if (altype == 'LastMile') {
              await this.getAWBForAutoAllocation(i, this.selectedroute[i].id, this.selectedroute[i].routename, clientid, altype, pincode, 3)
            }
          } else {
            // is FM LM picndoe is not there only client is selected then fetch FM and LM shipment for that client
              altype = 'LastMile';
              await this.getAWBForAutoAllocation(i, this.selectedroute[i].id, this.selectedroute[i].routename, clientid, altype, pincode, 1)
              await this.getAWBForAutoAllocation(i, this.selectedroute[i].id, this.selectedroute[i].routename, clientid, altype, pincode, 3)
              altype = 'FirstMile';
              await this.getAWBForAutoAllocation(i, this.selectedroute[i].id, this.selectedroute[i].routename, clientid, altype, pincode, 0)
          }
          if (this.allocatedawb.length > 9  && !this.forcestopBtn && !this.savebookingallocationflag) {
            this.selectedBookingQueue = this.allocatedawb;
            this.allocatedawb = []
            // this.savebookingallocationflag = true;
            this.saveTripAllocation(i, this.selectedroute[i].routename);
          }
          if (this.forcestop || this.forcestopBtn) {
            break;
          }
        }
        if (this.allocatedawb.length > 0 && !this.forcestopBtn && !this.savebookingallocationflag) {
          this.selectedBookingQueue = this.allocatedawb;
          this.allocatedawb = []
          // this.savebookingallocationflag = true;
          this.saveTripAllocation(i, this.selectedroute[i].routename);
        }
        if ((i==(this.selectedroute.length -1)) && this.allocatedawb.length > 0  && !this.forcestopBtn) {
          while (this.savebookingallocationflag) {
            await this.sleep(1500)
          }
          this.selectedBookingQueue = this.allocatedawb;
          this.allocatedawb = []
          // this.savebookingallocationflag = true;
          await this.saveTripAllocation(i, this.selectedroute[i].routename);
        }
        if (this.forcestop || this.forcestopBtn) {
          break;
        }
        if (i == this.selectedroute.length-1) {
          this.$set(this.currentroute, i , 'Completed')
        }
      }
      // this.$root.$refs.tripallocation.getSelectedAWBForTrip();
      // this.$root.$refs.tripallocation.getNotAllocatedShipment();
      this.allocationstatus = "Allocation Completed"
      while(this.currentrouteindex < this.selectedroute.length) {
        if (this.currentroute[this.currentrouteindex] === 'Completed') {
          this.$set(this.currentroute, this.currentrouteindex , 'Completed');
        } else {
          this.$set(this.currentroute, this.currentrouteindex , 'Stopped');
        }
        if (((Number(this.VehicleCapacity) - Number(this.allocatedweightfm))/Number(this.VehicleCapacity) < 0) && ((Number(this.VehicleCapacity) - Number(this.allocatedweightlm))/Number(this.VehicleCapacity) < 0)) {
          this.allocationstopmessage = "Auto-allocation stopped due to vehicle capacity reached"
        } else if (this.forcestopBtn) {
          this.allocationstopmessage = "Auto-allocation stopped by user."
        } else {
          this.allocationstopmessage = "Auto-allocation completed."
        }
        this.currentrouteindex = this.currentrouteindex + 1;

      }
      this.loaderFlag = false;
    },
    closeAllocationModal() {
      this.showAllocationModal = false;
    },
    setRoutepriority(action, item, index) {
      try {
        if (action === 'up') {
          let tmp = this.selectedroute[index]
          this.$set(this.selectedroute, index , this.selectedroute[index - 1])
          this.$set(this.selectedroute, index-1 , tmp)
        } else {
          let tmp = this.selectedroute[index]
          this.$set(this.selectedroute, index , this.selectedroute[index + 1])
          this.$set(this.selectedroute, index+1 , tmp)

        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAvilableroute() {
      try {
        let InputPayload = {
          hubid: this.HubId,
          sruserid: Number(this.srUserId)
        };
        let result = await TripServices.getAvilableRoute(InputPayload);
        let routeList = await result.data.data;
        this.routeDetailsList= routeList;
        if(this.routeDetailsList.length > 0) {
          this.parentObj.autoallocate = true;
          this.autoallocatepocflag=true;
          this.srroutemapping();
        } else {
          this.parentObj.autoallocate = false;
          this.autoallocatepocflag=false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAWBForAutoAllocation(index, routeid, route, clientid, altype, pincode, lmcheck){
      try {
        let offset = 1
        let pageLimit = this.getawblimit;
        let totalCount = 0
        let currPage = 0
        let totalPage =0
        let lmallocation1count = 0
        let firstlmiteration = true
        let secondlmiteration = false
        let dt = moment().tz("Asia/Kolkata").format('YYYY-MM-DD');
        let weightPercentage = (Number(this.VehicleCapacity) - Number(this.allocatedweight))/Number(this.VehicleCapacity)
        let weightPercentagefm = (Number(this.VehicleCapacity) - Number(this.allocatedweightfm))/Number(this.VehicleCapacity);
        let weightPercentagelm = (Number(this.VehicleCapacity) - Number(this.allocatedweightlm))/Number(this.VehicleCapacity);
        while(((weightPercentagefm >= this.cutoffweight) || (weightPercentagelm >= this.cutoffweight))  && currPage <= totalPage && !this.forcestop && !this.forcestopBtn) {
          currPage = currPage +1
          let inputPayload = {
            hubid: this.HubId,
            lastmodifiedby: this.userName,
            "offset": offset,
            "limit": pageLimit,
            "type":altype,
          }
          if(clientid !== 0 && clientid !== ""){
            inputPayload.ClientId = clientid
          }
          if(pincode != ""){
            inputPayload.PickupPinCode = pincode
          }
          if(altype == 'FirstMile') {
            inputPayload.FromDate = dt
            inputPayload.ToDate = dt
          }
          if(altype == 'LastMile' && lmcheck!=3) {
            inputPayload.isautoallocation = 1
          }
          if(altype == 'LastMile' && !firstlmiteration && lmallocation1count <= 0 && lmcheck!=3) {
            inputPayload.isautoallocation = 2
            secondlmiteration = true
          }
          if(altype == 'LastMile' && lmcheck==3) {
            inputPayload.isautoallocation = 3
          }
          let result = await TripServices.GetBookingAllocations(inputPayload)
          if(result.data.code == 200){
          totalCount = Number(result.data.data.count);
          if(altype == 'LastMile' && inputPayload.isautoallocation != undefined && inputPayload.isautoallocation == 1 && firstlmiteration) {
            lmallocation1count = totalCount
            firstlmiteration = false
          }
          if(totalCount>0){
            let tmpdata = result.data.data.rows.map(async (el)=>{
              let item = {
                'AWB':el.awbnumber,
                'AWBStatus':el.awbstatus,
                'UserProcess':el.userprocess,
                'ClientName':el.clientname,
                'ClientId': el.clientid,
                "Address":el.address,
                'DeliveryPincode':el.deliverypincode,
                'NumberofMPS': altype == 'LastMile'? el.numberofmps : (el.numberofmps == el.bookedmps ? el.numberofmps : el.bookedmps),
                'NumberofBookedMPS': el.bookedmps,
                'TotalWeight':el.totalwt,
                'TotalPhyWt': el.totalphywt,
                'TotalVolWt':el.totalvolwt,
                'NumberofEWB':el.numberofewb?el.numberofewb:'2',
                'AWBRADDate':el.awbcreateddate,
                'ValueAddedServices':'Appointment Delivery',
                'State': el.state,
                'City': el.city,
                'EwayBillNo': el.ewaybillnumber,
                'EbnExpiryDate': el.ebnexpirydate,
                'GST': el.gst,
                'BookingMode': el.bookingmode,
                'VTCPaymentMode': el.vtcpaymentmode,
                'DeliveryDatetime': el.deliverydatetime,
                'MallDelivery': el.malldelivery,
                'BeneficiaryName': el.beneficiaryname,
                'CollectionAmount': el.collectionamount,
                'AlreadyAssign': el.alreadyassign,
                'TripId': el.tripid?el.tripid:'',
                'TotalInvoice': el.totalinvoice,
                'RouteMode': el.routemode,
                'bookingpickuppincode':el.bookingpickuppincode,
                'bookingdestinationpincode':el.bookingdestinationpincode,
                'clientbusinessaccountid':el.clientbusinessaccountid,
                'dropname':el.dropname,
                'dropconsigneecode':el.dropconsigneecode,
                'disable':(el.disable == 1 || el.disable == 2) ? 0 : el.disable,
                'pickupslotsdate':el.pickupslotsdate,
                'deliveryslotsdate':el.deliveryslotsdate,
                'isreallocationallowed':el.isreallocationallowed,
                'intrastate': el.intrastate,
                'activecontractid':el.activecontractid,
                'bookingsource': el.bookingsource,
                'allocationflag': 2,
                'allocationroute': routeid,
                'PhoneNumber':el.phonenumber,
                'businessunit':el.businessunit?el.businessunit: null,
                'disablereason' : el.disablereason,
				'clientmpsitemqty':el.clientmpsitemqty,
              }
              var appointmendateCheck=false;
              var nprndrdateCheck=false;
              if (altype == "LastMile") {
                item.requestedpickupdate=el.pdddate
                item.appntdateflag = el.appntdateflag;
                item.ftcamount = el.ftcamount;
                item.exceptionalservice = " ";
                item.ispartialdelivery = el.ispartialdelivery;
                item.allocationtype = "lastmile"
                if (el.appointmentdate) {
                  let appointmentDate=moment(el.appointmentdate,'YYYY-MM-DD')
                  let todayDate=moment()
                  if(appointmentDate>todayDate) {
                    appointmendateCheck=true;
                  }
                }
                if (el.deliveryslotsdate) {
                  let nprndrdate=moment(el.deliveryslotsdate,'DD-MM-YYYY')
                  let todayDate=moment().tz('Asia/Kolkata')
                  if(nprndrdate>todayDate) {
                    nprndrdateCheck=true;
                  }
                }
                if (el.pdddate && el.appointmentdate) {
                  let todayDate=moment().format('YYYY-MM-DD')
                  let appointmentDate=moment(el.appointmentdate).format('YYYY-MM-DD')
                  let pdddateDate=moment(el.pdddate,'DD-MM-YYYY').format('YYYY-MM-DD')
                  if (appointmentDate>pdddateDate && pdddateDate>=todayDate) {
                    appointmendateCheck=true;
                  }
                }
              } else {
                item.allocationtype = "firstmile"
                item.requestedpickupdate=el.pickupslotsdate
                if (el.pickupslotsdate) {
                  let nprndrdate=moment(el.pickupslotsdate,'DD-MM-YYYY')
                  let todayDate=moment().tz('Asia/Kolkata')
                  if(nprndrdate>todayDate) {
                    nprndrdateCheck=true;
                  }
                }
              }
              // moment().tz('Asia/Kolkata').format('DD/MM/YYYY')
              // if (this.notautoallocated[index] && !Object.keys(this.notautoallocated[index]).length) {
              //   this.notautoallocated[index] = {}
              // }
              if (!("alreadyassign" in el)) {
                item.AlreadyAssign=0
              }
              if (altype == "FirstMile") {
                if (!nprndrdateCheck) {
                  if (item.disable != 5 ) {
                      if ((item.disable != 1 || item.disable != 2 || item.disable != 0) && item.AlreadyAssign == 0 && item.NumberofMPS) {
                      if ((Number(this.VehicleCapacity) - (Number(this.allocatedweightfm)+Number(el.totalphywt)))/Number(this.VehicleCapacity) >= (this.cutoffweight)) {
                        if (true) {
                          if (!this.allocatedlist[index]) {
                            this.allocatedlist[index] = []
                          }
                          this.allocatedlist[index].push(item.AWB)
                          this.allocatedawb.push(item)
                        } else {
                          let comment = 'MPS count is greatter than 100.';
                          this.logautoallocationerror(item.AWB, index, route, 'FirstMile', comment)
                        }
                      } else {
                        let comment = `Shipment not added due to overweight.`;
                        this.logautoallocationerror(item.AWB, index, route, 'FirstMile', comment);
                        if ((Number(this.VehicleCapacity) - Number(this.allocatedweightfm))/Number(this.VehicleCapacity) < (this.cutoffweight)) {
                          this.allocationstopmessage= "Auto Allocation stopped due to vehicle capacity reached."
                          this.forcestop = true;
                        }
                      }
                    } else  {
                      let comment = item.AlreadyAssign?`AWB already assigned to tripid ${item.TripId}`:!item.NumberofMPS?`Number of MPS is empty`:!item.TotalWeight?`Total Weight is empty`:item.disable == 1?`Pick-up Scheduled at ${item.pickupslotsdate}`:item.disable == 2 ? `Reallocation not allowed`: item.disable == 5 ? item.disablereason : '1';
                      this.logautoallocationerror(item.AWB, index, route, 'FirstMile', comment)
                    }
            }else{
              let comment = item.disablereason;
              this.logautoallocationerror(item.AWB, index, route, 'FirstMile', comment)
            }
              } else {
                let comment = `Re-schedule Date is set at ${moment(item.pickupslotsdate,'DD-MM-YYYY').format('DD-MM-YYYY').valueOf()}`;
                this.logautoallocationerror(item.AWB, index, route, 'FirstMile', comment)
              }
              } else if (altype == "LastMile" ) {
                lmallocation1count--
                let allocatedObj = {}
                if (!appointmendateCheck && !nprndrdateCheck) {
                if (!(item.AlreadyAssign==1 || item.NumberofMPS==null || item.TotalWeight == null || item.disable == 1 || item.disable == 2 || item.disable == 3 || item.disable == 4 || item.disable == 5 || item.appntdateflag == 1)) {
                  if (el.dropname && el.dropconsigneecode) {
                    if((Number(this.VehicleCapacity) - (Number(this.allocatedweightlm)+Number(el.totalphywt)))/Number(this.VehicleCapacity) >= (this.cutoffweight)){
                      if (!this.allocatedlist[index]) {
                        this.allocatedlist[index] = []
                      }
                      if(this.allocatedawb.indexOf(item.AWB) == -1) {
                        this.allocatedlist[index].push(item.AWB)
                        this.allocatedawb.push(item)
                      }
                    } else {
                      let comment = `Shipment not added due to overweight.`;
                      this.logautoallocationerror(item.AWB, index, route, 'LastMile', comment);
                      if ((Number(this.VehicleCapacity) - Number(this.allocatedweightlm))/Number(this.VehicleCapacity) < (this.cutoffweight)) {
                        this.allocationstopmessage= "Auto Allocation stopped due to vehicle capacity reached."
                        this.forcestop = true;
                      }
                    }
                  } else {
                    let comment = `Please perform complete booking.`;
                    this.logautoallocationerror(item.AWB, index, route, 'LastMile', comment);
                  }
                } else {
                  let comment = item.AlreadyAssign?`AWB already assigned to tripid ${item.TripId}`:!item.NumberofMPS?`Number of MPS is empty`:!item.TotalWeight?`Total Weight is empty`:item.disable == 1?`Pick-up Scheduled at ${item.pickupslotsdate}`:item.disable == 2 ? `Reallocation not allowed`: item.disable == 3 ? `Cash Memo is not generated for this FTC shipment`: item.disable == 4 ? `Cash Memo is expired for this FTC shipment, please Re-generate Cash Memo.`: item.appntdateflag == 1? `Appointment Date is set at ${moment.utc(item.DeliveryDatetime).format("DD-MM-YYYY").valueOf()}`: item.disable == 5 ? item.disablereason :'';
                  this.logautoallocationerror(item.AWB, index, route, 'LastMile', comment);
                }
              } else {
                  if (appointmendateCheck) {
                    let comment = `Appointment Date is set at ${moment.utc(item.DeliveryDatetime).format("DD-MM-YYYY").valueOf()}`;
                    this.logautoallocationerror(item.AWB, index, route, 'LastMile', comment);
                  } else {
                    let comment = `Re-schedule Date is set at ${moment(item.deliveryslotsdate,'DD-MM-YYYY').format('DD-MM-YYYY').valueOf()}`;
                    this.logautoallocationerror(item.AWB, index, route, 'LastMile', comment)
                  }
                }
              }
            })
            if (this.allocatedawb.length > 0 && !this.savebookingallocationflag) {
              this.selectedBookingQueue = this.allocatedawb;
              this.allocatedawb = []
              // this.savebookingallocationflag = true;
              this.saveTripAllocation(index, route);
            }
            if (this.forcestop || this.forcestopBtn) {
              break;
            }
          }else{
            if (this.forcestop || this.forcestopBtn) {
              break;
            }
          }

        } else {
          if(altype == 'LastMile' && inputPayload.isautoallocation != undefined && inputPayload.isautoallocation == 1 && firstlmiteration) {
            firstlmiteration = false
          }
        }

        if (totalCount < pageLimit) {
          totalPage = 1
        } else {
          totalPage = Math.ceil(totalCount / pageLimit);
        }
        offset = (currPage - 1) * pageLimit
        offset = offset + 1
      }
      } catch(err){
        console.log(err);
        // await this.getAWBForFirstmile();
        // this.isLoading = false;
      }
    },
    async saveTripAllocation(index, route){
      try {
        if(this.selectedBookingQueue.length == 0){
          this.savebookingallocationflag = false;
          return false
        }
        let addedAWB=[]
        this.savebookingallocationflag = true;
        let shipmeAllocationType={}
        this.expireEBN = []
        this.ewbarr = []
        this.awberr = ''
        let validationPayloadFM = {
          awbarray: [],
          shipmenttype: 'firstmile'
        }
        let validationPayloadLM = {
          awbarray: [],
          shipmenttype: 'lastmile'
        }
        let EWBValidationPayload = {
          ewbarray: []
        }
        let overweightAWB= [];
        let assignedloadAWB = this.allocatedweight ? this.allocatedweight : 0;
        let assignedloadAWBfm = this.allocatedweightfm ? this.allocatedweightfm : 0;
        let assignedloadAWBlm = this.allocatedweightlm ? this.allocatedweightlm : 0;
        let finalAWBArr = this.selectedBookingQueue.map(obj => {
          if (!addedAWB.some(el => el==obj.AWB)) {
            addedAWB.push(obj.AWB)
          let ewbarr = []
          if(obj.GST.length>0){
            obj.GST.forEach(element=>{
              if(element.ewaybillsrnumber){
                ewbarr.push({
                  "EWB":element.ewaybillsrnumber,
                  "PartBupdated":1
                })
              }
            })
          }
          if (obj.allocationtype == 'firstmile') {
            validationPayloadFM.awbarray.push(obj.AWB)
          } else {
            validationPayloadLM.awbarray.push(obj.AWB)
          }
          // if ((Number(assignedloadAWB) + Number(obj.TotalPhyWt)) > Number(this.VehicleCapacity)) {
          //   console.log(obj.AWB, assignedloadAWB, obj.TotalPhyWt, this.VehicleCapacity);
          //   overweightAWB.push(obj.AWB)
          // } else {
          //   assignedloadAWB = (Number(assignedloadAWB) + Number(obj.TotalPhyWt))
          // }
          shipmeAllocationType[obj.AWB]=obj.allocationtype=='firstmile'? 'FirstMile' : 'LastMile'
          let temp = {
            'tripid': this.tripID,
            'awbnumner':obj.AWB,
            "activecontractid":obj.activecontractid,
            'awbstatus': 'allocsr',
            'clientid':obj.ClientId,
            'address': obj.Address,
            'clientname':obj.ClientName,
            'pickuppincode':obj.DeliveryPincode,
            'numberofmps':obj.NumberofMPS,
            'bookingmpscount':obj.NumberofBookedMPS,
            'totalwt':obj.TotalWeight,
            'totalphywt': obj.TotalPhyWt,
            'bookingphywt': obj.TotalPhyWt,
            'totalvolwt':obj.TotalVolWt,
            'awbcreateddate': obj.AWBRADDate,
            'lastmodifiedby':this.userName,
            'allocationtype': obj.allocationtype,
            'state': obj.State,
            'city': obj.City,
            'bookingmode': obj.BookingMode,
            'hubid': Number(this.HubId),
            'totalinvoice': Number(obj.TotalInvoice),
            'routemode': obj.RouteMode,
            'bookingpickuppincode':obj.bookingpickuppincode,
            'bookingdestinationpincode':obj.bookingdestinationpincode,
            "clientbusinessaccountid":obj.clientbusinessaccountid,
            'dropname':obj.dropname?obj.dropname:"",
            'dropconsigneecode':obj.dropconsigneecode?obj.dropconsigneecode:"0",
            'vts': {
              'vtcpaymentmode': obj.VTCPaymentMode? obj.VTCPaymentMode.toString(): '',
              'deliverydatetime': obj.DeliveryDatetime? obj.DeliveryDatetime: '',
              'malldelivery': obj.MallDelivery? obj.MallDelivery: '',
              'beneficiaryname': obj.BeneficiaryName? obj.BeneficiaryName: '',
              'collectionamount': obj.CollectionAmount? obj.CollectionAmount.toString(): ''
            },
            'ewbnumber':ewbarr,
            'intrastate':obj.intrastate,
            'bookingsource':obj.bookingsource,
            'allocationflag': obj.allocationflag,
            'allocationroute': Number(obj.allocationroute),
            'consigneephonenumber':obj.PhoneNumber,
            'ftcamount': obj.ftcamount?obj.ftcamount:null,
            'businessunit':obj.businessunit?obj.businessunit: null,
          }
          if (obj.allocationtype=='firstmile') {
            temp.requestedpickupdate=obj.requestedpickupdate
          } else {
            temp.requestedpickupdate=obj.requestedpickupdate
          }
          // 'ewbnumber':ewbarr,
          if(obj.GST.length > 0){
            obj.GST.map(el => {
              if(el.ewaybillsrnumber){
                if(EWBValidationPayload.ewbarray.indexOf(el.ewaybillsrnumber) == -1){
                  EWBValidationPayload.ewbarray.push(el.ewaybillsrnumber)
                }
              }
            })
          }
          return temp
        }
        })
        finalAWBArr = finalAWBArr.filter(item => item)
        if(EWBValidationPayload.ewbarray.length > 0){
          let EWBValidateResult = await TripServices.ValidateEWBExpiry(EWBValidationPayload);
          if(EWBValidateResult.data.code == 200){
            this.selectedBookingQueue.map(el => {
              EWBValidateResult.data.data.map(async obj => {
                if (Array.isArray(el.EwayBillNo) && el.EwayBillNo.indexOf(obj.toString()) != -1) {
                  this.logautoallocationerror(el.AWB, index, route, shipmeAllocationType[el.AWB], "Expired EWB")
                  this.allocatedlist.forEach((item, i) => {
                    this.allocatedlist[i] = this.allocatedlist[i].filter(e => e !== el.AWB);
                  })
                  // this.allocatedlist = this.removeByAttr(this.allocatedlist,'AWB', el.AWB)
                  finalAWBArr = await this.removeByAttr(finalAWBArr,'awbnumner', el.AWB)
                }
              })
            })
          }
        }
        if (validationPayloadFM.awbarray.length > 0) {
          let validateAWB = await TripServices.ValidateAllocatedAWb(validationPayloadFM);
          if(validateAWB.data.code == 200){
            validateAWB.data.data.map(async el => {
              this.logautoallocationerror(el.awb, index, route, shipmeAllocationType[el.AWB], "Mention AWB already allocated")
              this.allocatedlist.forEach((item, i) => {
                this.allocatedlist[i] = this.allocatedlist[i].filter(e => e !== el.awb);
              })
              // this.allocatedlist = this.removeByAttr(this.allocatedlist,'AWB', el.awb)
              finalAWBArr = await this.removeByAttr(finalAWBArr,'awbnumner', el.awb)
            })
          }
        }
        if (validationPayloadLM.awbarray.length > 0) {
          let validateAWB = await TripServices.ValidateAllocatedAWb(validationPayloadLM);
          if(validateAWB.data.code == 200){
            validateAWB.data.data.map(async el => {
              this.logautoallocationerror(el.awb, index, route, shipmeAllocationType[el.AWB], "Mention AWB already allocated")
              this.allocatedlist.forEach((item, i) => {
                this.allocatedlist[i] = this.allocatedlist[i].filter(e => e !== el.awb);
              })
              // this.allocatedlist = this.removeByAttr(this.allocatedlist,'AWB', el.awb)
              finalAWBArr = await this.removeByAttr(finalAWBArr,'awbnumner', el.awb)
            })
          }
        }
        let weghtCheck=[]
        for (let index = 0; index < finalAWBArr.length; index++) {
          if (weghtCheck.includes(finalAWBArr[index].awbnumner)) {
            finalAWBArr = await this.removeByAttrSingle(finalAWBArr,'awbnumner', finalAWBArr[index].awbnumner)
          } else {
          if (finalAWBArr[index].allocationtype == 'firstmile' && (((Number(this.VehicleCapacity) - (Number(assignedloadAWBfm) + Number(finalAWBArr[index].totalphywt))) /Number(this.VehicleCapacity)) < (this.cutoffweight))) {
            overweightAWB.push(finalAWBArr[index].awbnumner)
          } else {
            assignedloadAWBfm = (Number(assignedloadAWBfm) + Number(finalAWBArr[index].totalphywt))
            weghtCheck.push(finalAWBArr[index].awbnumner)
          }
          if (finalAWBArr[index].allocationtype == 'lastmile' && (((Number(this.VehicleCapacity) - (Number(assignedloadAWBlm) + Number(finalAWBArr[index].totalphywt))) /Number(this.VehicleCapacity)) < (this.cutoffweight))) {
            overweightAWB.push(finalAWBArr[index].awbnumner)
          } else {
            assignedloadAWBlm = (Number(assignedloadAWBlm) + Number(finalAWBArr[index].totalphywt))
            weghtCheck.push(finalAWBArr[index].awbnumner)
          }
          }
        }
        if (overweightAWB.length > 0) {
          overweightAWB.forEach(async (awb) => {
            this.logautoallocationerror(awb, index, route, shipmeAllocationType[awb], "Shipment not added due to overweight.")
            this.allocatedlist.forEach((item, i) => {
              this.allocatedlist[i] = this.allocatedlist[i].filter(e => e !== awb);
            })
            this.testremovedawb.push(awb)
            finalAWBArr = await this.removeByAttr(finalAWBArr,'awbnumner', awb)
          })
        }

        if(finalAWBArr.length > 0){
          // finalAWBArr.forEach(item => {
          //   this.allocatedweight = this.allocatedweight + item.totalwt
          // })
          let input = {
            AWBArray: finalAWBArr,
            updatedby : this.userName
          }
          let totalAwbWeight = 0
          let totalAwbWeightfm = 0
          let totalAwbWeightlm = 0
          finalAWBArr.forEach(item => {
            this.testallotedawb.push(item.awbnumner);
            this.testweight.push(item.totalphywt);
            totalAwbWeight += item.totalphywt
            if (item.allocationtype == 'firstmile') {
              totalAwbWeightfm += item.totalphywt
            } else if (item.allocationtype == 'lastmile') {
              totalAwbWeightlm += item.totalphywt
            }
          });
          let assignedload = this.allocatedweight ? this.allocatedweight : 0;
          let assignedloadfm = this.allocatedweightfm ? this.allocatedweightfm : 0;
          let assignedloadlm = this.allocatedweightlm ? this.allocatedweightlm : 0;
          let loadchekdisable = true;
          if ((((Number(this.VehicleCapacity) - (Number(assignedloadfm) + Number(totalAwbWeightfm))) /Number(this.VehicleCapacity)) < (this.cutoffweight)) && (((Number(this.VehicleCapacity) - (Number(assignedloadlm) + Number(totalAwbWeightlm))) /Number(this.VehicleCapacity)) < (this.cutoffweight))) {
            let overload =  (Number(assignedload) + totalAwbWeight) - this.VehicleCapacity
            // this.$alert(`Selected AWBs weighs more than vehicle capacity by ${overload.toFixed(2)} KGS `, "OVERLOAD", "error");
            this.isLoading = false
            this.savebookingallocationflag = false;
          } else {
            this.saveallocationflag=true;
            let result = await TripServices.createFirstMileTripAllocation(input);
            this.isLoading = false
            this.selectedBookingQueue = [];
            this.savebookingallocationflag = false;
            if (result.data.code == 200) {
              result.data.data.forEach((item) => {
                if (item.code == 200) {
                  // this.allocatedweight = Number(this.allocatedweight) + Number(item.data.awbResult.totalphysicalwt);
                  if (item.data.awbResult.allocationtype=='firstmile') {
                    this.allocatedweightfm = Number(this.allocatedweightfm) + Number(item.data.awbResult.totalphysicalwt);
                  } else {
                    this.allocatedweightlm = Number(this.allocatedweightlm) + Number(item.data.awbResult.totalphysicalwt);
                  }
                  for (let i = 0; i < this.allocatedlist.length; i++) {
                    if(this.allocatedlist[i] && this.allocatedlist[i].indexOf(item.data.awbResult.awb) != -1) {
                      if(!this.allocatedToTrip[i]){
                        this.allocatedToTrip[i] = []
                        this.allocatedToTripFm[i] = []
                        this.allocatedToTripLm[i] = []
                      }
                      this.allocatedToTrip[i].push(item.data.awbResult.awb)
                      if (item.data.awbResult.allocationtype=='firstmile') {
                        this.allocatedToTripFm[i].push(item.data.awbResult.awb);
                      }
                      if (item.data.awbResult.allocationtype=='lastmile') {
                        this.allocatedToTripLm[i].push(item.data.awbResult.awb);
                      }
                      this.notautoallocated = this.removeByAttr(this.notautoallocated,'AWB', item.data.awbResult.awb)
                    }

                  }
                  // this.allocatedToTrip.push(item.data.awbResult.awb);
                }
              })

            }
            this.saveallocationflag=false;
          }
        }
        this.savebookingallocationflag = false;
        this.selectedBookingQueue = [];
        finalAWBArr=[]

      } catch(err){
        console.log(err);
        this.saveallocationflag=false;
        this.isLoading = false;
      }
    },
    removeByAttr(arr, attr, value){
      var i = arr.length;
      while(i--){
         if( arr[i] && arr[i].hasOwnProperty(attr) && (arguments.length > 2 && arr[i][attr] === value ) ) {
             arr.splice(i,1);
         }
      }
      return arr;
    },
    removeByAttrSingle(arr, attr, value){
      var i = arr.length;
      while(i--){
         if( arr[i] && arr[i].hasOwnProperty(attr) && (arguments.length > 2 && arr[i][attr] === value ) ) {
             arr.splice(i,1);
             break;
         }
      }
      return arr;
    },
    logautoallocationerror(awbnumber, index, route="", allocationtype ="", comment="") {
      let checkawb=0
      let checkawbnot=0;
      this.allocatedToTrip.forEach((item) => {
        if (item.includes(awbnumber)) {
          checkawb =1;
        }
      })
      this.allocatedToTripFm.forEach((item) => {
        if (item.includes(awbnumber)) {
          checkawb =1;
        }
      })
      this.allocatedToTripLm.forEach((item) => {
        if (item.includes(awbnumber)) {
          checkawb =1;
        }
      })
      this.notautoallocated.forEach((item) => {
        if (item.AWB == (awbnumber)) {
          checkawbnot =1;
        }
      })
      if (checkawb!==1 && checkawbnot==0) {
        let tmperror = {
          'AWB' : awbnumber,
          'routename' : route,
          'shipmenttype' : allocationtype,
          'status' : comment
        }
        this.notautoallocated.push(tmperror)
      }
    },
    ShowNotallocated() {
      this.showNotallocated = !this.showNotallocated
    },
    stopAutoallocation() {
      this.forcestopBtn = true
      this.savebookingallocationflag=false;
    },
    fixedToDecimalPlace(data) {
      return Number(data).toFixed(2)
    },
    srroutemapping() {
      this.routeDetailsList.forEach((item) => {
        if (item.selected) {
          this.selectedroute.push(item)
        }
      })
    },
    showmodal(action) {
      try {
        document.querySelector(".custom-modal").classList.toggle("show-custom-modal");
        this.showRouteSelection = false;
        if (action=='close') {
          this.resetautoallocation()
          this.$root.$refs.tripallocation.getSelectedAWBForTrip();
          this.$root.$refs.tripallocation.getNotAllocatedShipment();
        } else {
          this.startAutoAllocation()
        }

      } catch (error) {
        console.log(error);
      }
    },
    resetautoallocation(){
      this.showRouteSelection=false;
      this.showAllocationModal= false;
      // this.routeDetailsList= [];
      this.selectedroute= [];
      this.allocationstatus= "In Progress";
      // this.vehicleweght= 50;
      this.allocatedweight= 0;
      this.allocatedweightfm= 0;
      this.allocatedweightlm= 0;
      this.allocatedawb= [];
      this.allocatedlist= [];
      this.notautoallocated=[];
      this.forcestop= false;
      this.forcestopBtn= false;
      this.showNotallocated= false;
      this.savebookingallocationflag= false;
      this.selectedBookingQueue= [];
      this.allocatedToTrip=[];
      this.allocatedToTripFm=[];
      this.allocatedToTripLm=[];
      this.currentroute=[];
      this.currentrouteindex=0;
      this.loaderFlag=false;
      this.saveallocationflag=false;
      this.testallotedawb= [];
      this.testremovedawb=[];
      this.testweight=[];
      this.allocationstopmessage="";
      this.srroutemapping();
    },
    async getAutoAllocationconfig() {
      try {
        let input={}
        let result = await TripServices.getAutoallocationConfig(input)
        if (result.data.code == 200) {
          let data = result.data.data;
          if (data.cutoffpercentage) {
            this.cutoffweight= data.cutoffpercentage;
          }
          if (data.fetchlimit) {
            this.getawblimit=data.fetchlimit;
          }
          // if (data.pocflag == 1) {
          //   this.autoallocatepocflag = data.hublist.includes(this.HubId);
          // }
        }

      } catch (error) {
        console.log(error);
      }
    },
    async sleep(milliseconds) {
      await new Promise(resolve => {
        return setTimeout(resolve, milliseconds)
    });
    },
    async getOpenPickupDeliveryClients(){
      try {
        this.isLoading = true;
        let inputPayload = {
          key:"openpickupdelivery"
        };
        let result = await AdminSettingsService.getOpenPickupDeliveryClientst(inputPayload)
        if(result.data.code == 200){
          this.openpickupdeliveryclients = result.data.data;
        }
        this.isLoading = false;	
      } catch (error) {
        this.isLoading = false;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/CreateTripManagement/CreateTripManagement.component.js